//import { CommonService } from './../../shared/utility/common.service';
import { Component, Input, ChangeDetectorRef, HostListener, ChangeDetectionStrategy, OnInit, AfterViewInit, Output, EventEmitter } from '@angular/core';
import { D3Service, ForceDirectedGraph, Link, Node } from '../../d3';
@Component({
    selector: 'graph',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        <svg #svg [attr.width]="_options.width" [attr.height]="_options.height">
            <g [zoomableOf]="$any(svg)">
                <g [linkVisual]="link" *ngFor="let link of links"></g>
                <g
                    [nodeVisual]="node"
                    *ngFor="let node of nodes"
                    (click)="nodeSingleClicked(node)"
                    [draggableNode]="node"
                    [draggableInGraph]="graph"
                    [hoverableNode]="node"
                    [hoverableInGraph]="graph"
                ></g>
            </g>
        </svg>
    `,
})
export class GraphComponent implements OnInit, AfterViewInit {
    @Input('nodes')
    nodes!: Array<Node>;
    @Input('links')
    links!: Array<Link>;
    graph!: ForceDirectedGraph;
    _options: { width: any; height: any } = { width: 800, height: 600 };
    @Output() nodeDoubleClickEmmiter: EventEmitter<any> = new EventEmitter();
    @Output() nodeSingleClickEmmiter: EventEmitter<any> = new EventEmitter();

    @HostListener('window:resize', ['$event'])
    onResize() {
        this.graph.initSimulation(this.options);
    }
    preventSimpleClick: any;
    timer: any;
    touchtime = 0;
    constructor(
        private d3Service: D3Service,
        private ref: ChangeDetectorRef,
        //  private commonService: CommonService,
    ) {}

    ngOnInit() {
        this.initGraph();
    }

    ngOnChanges() {
        this.initGraph();
    }

    initGraph() {
        /** Receiving an initialized simulated graph from our custom d3 service */
        this.graph = this.d3Service.getForceDirectedGraph(this.nodes, this.links, this.options);
        /** Binding change detection check on each tick
         * This along with an onPush change detection strategy should enforce checking only when relevant!
         * This improves scripting computation duration in a couple of tests I've made, consistently.
         * Also, it makes sense to avoid unnecessary checks when we are dealing only with simulations data binding.
         */
        this.graph.ticker.subscribe(() => {
            this.ref.markForCheck();
        });
    }

    nodeSingleClicked(node: Node) {
        if (this.touchtime == 0) {
            // set first click
            this.touchtime = new Date().getTime();
        } else {
            // compare first click to this click and see if they occurred within double click threshold
            if (new Date().getTime() - this.touchtime < 500) {
                // double click occurred
                this.nodeDoubleClicked(node);
                this.touchtime = new Date().getTime();
            } else {
                // not a double click so set as a new first click
                this.touchtime = new Date().getTime();

                this.timer = 0;
                this.preventSimpleClick = false;
                const delay = 300;
                this.timer = setTimeout(() => {
                    if (!this.preventSimpleClick) {
                        this.nodeSingleClickEmmiter.emit(node);
                    }
                }, delay);
            }
        }
    }

    nodeDoubleClicked(node: Node) {
        this.preventSimpleClick = true;
        clearTimeout(this.timer);
        this.nodeDoubleClickEmmiter.emit(node);
        if (node.data.data.type == 1) {
            //  this.commonService.callTOCArticleFromSKGSubject.next(node);
        } else {
            let reqConceptNondeSummary = {};
            if (node.data.data.isDummy) {
                reqConceptNondeSummary = {
                    id: node.data.data.actualId,
                    relevantArticle: 0,
                    text: node.data.data.label,
                };
            } else {
                reqConceptNondeSummary = {
                    id: node.data.data.id,
                    relevantArticle: 0,
                    text: node.data.data.label,
                }; // else send it as node payload
            }
            if (!node.isArticleNetworkNode) {
                // this.commonService.callConceptArticleFromSKGSubject.next(reqConceptNondeSummary);
                // this.commonService.activateTOCNodeSubject.next(false);
            }
        }
    }

    ngAfterViewInit() {
        this.graph.initSimulation(this.options);
    }

    get options() {
        // console.log("__________",window.innerHeight);
        // console.log("__________",window.innerWidth);
        return (this._options = {
            width: window.innerWidth,
            height: window.innerHeight - 100,
        });
    }
}
